// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const RemoteExecutionIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.93 5H5.07A1.57 1.57 0 0 0 3.5 6.57V17.9a1.57 1.57 0 0 0 1.57 1.56h13.86a1.57 1.57 0 0 0 1.57-1.57V6.56A1.57 1.57 0 0 0 18.93 5m0 13.22H5.07a.34.34 0 0 1-.34-.34v-9.2h14.54v9.21a.34.34 0 0 1-.34.34" />
    <path d="M16.88 15.12h-4.44a.14.14 0 0 0-.14.14v.94q.02.13.14.14h4.44q.13-.01.14-.14v-.94a.14.14 0 0 0-.14-.14M8.21 10.36a.6.6 0 0 0-.87 0 .6.6 0 0 0 0 .85l2.04 2.04-2.04 2.04a.6.6 0 0 0 0 .87q.19.18.44.18t.43-.18l2.47-2.47a.6.6 0 0 0 0-.87z" />
  </svg>,
  "RemoteExecution",
);
export default RemoteExecutionIcon;
